import React, { useState, useEffect } from "react";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";

const CteTicketsFilterForm = ({
  applyFilter,
  internalStatus = [],
  reportees = [],
  localstorageKey = "cteComplaintList",
}) => {
  const filterInputs = {
    complain_id: "",
    infra_id: "",
    client_name: "",
    assignee_ids: "",
    internalStatus: "",
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);

  useEffect(() => {
    const saved = JSON.parse(
      localStorage.getItem(localstorageKey) &&
        localStorage.getItem(localstorageKey)
    );
    if (saved) {
      setFilterFieldsData({ ...filterInputs, ...saved });
    }
  }, [localstorageKey]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      <ConstantInput
        label={localization.ticketId}
        value={filterFieldsData.complain_id}
        regex={Regex.alphaNum.test(filterFieldsData.complain_id)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, complain_id: val })
        }
      />
      <ConstantInput
        label="Infra ID"
        value={filterFieldsData.infra_id}
        regex={Regex.alphaNum.test(filterFieldsData.infra_id)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, infra_id: val })
        }
      />
      <ConstantInput
        label={localization.siteName}
        value={filterFieldsData.client_name}
        regex={Regex.text.test(filterFieldsData.client_name)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, client_name: val })
        }
      />
      <DropDownInput
        disabled={reportees.length === 0}
        label={localization.assignee}
        data={reportees}
        getValueById={filterFieldsData.assignee_ids || ""}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, assignee_ids: val.id })
        }
      />
      <DropDownInput
        disabled={internalStatus.length === 0}
        label={localization.status}
        data={internalStatus}
        getValueById={filterFieldsData.internalStatus || ""}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, internalStatus: val.id })
        }
      />

      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            setFilterFieldsData(filterInputs);
            applyFilter(filterInputs);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default CteTicketsFilterForm;
